import { Component } from 'react'
import { observer } from 'mobx-react'
import * as d3 from 'd3'
import $ from 'jquery'
import ColorHash from 'color-hash'

import * as h from 'h'

import styles from './styles.scss'

@observer(['ExpertiseStore'])
export default class FacultyGraph extends Component {
  colorHash = new ColorHash({ saturation: 0.5 })

  componentDidMount () {
    const { authors, collaborators } = this.props.data

    this.loadNodes(authors)
    this.loadLinks(collaborators, authors)

    this.drawForceGraph(this.nodes, this.links)
  }

  loadNodes (authors) {
    this.nodes = authors.map(author => ({
      id: author.id,
      name: author.nameForGraph,
      score: author.score,
      department: author.department,
      url: author.facultyFaceUrl
    }))
  }

  loadLinks (collaborators, authors) {
    this.links = []
    const authorIds = authors.map(a => a.id)

    for (let author in collaborators) {
      if (!authorIds.includes(+author)) continue

      for (let collaborator in collaborators[author]) {
        if (!authorIds.includes(+collaborator)) continue

        this.links.push({
          id: `${author}+${collaborator}`,
          source: +author,
          target: +collaborator,
          score: collaborators[author][collaborator]
        })
      }
    }
  }

  drawForceGraph (nodes, links) {
    // Backend returns nodes sorted descending by score
    const minRadius = nodes[nodes.length - 1].score
    const maxRadius = nodes[0].score
    let scaleRadius = d3.scaleLinear()
      .domain([minRadius, maxRadius])
      .range([15, 45])

    const linkScores = links.map(l => l.score)
    const minLinkWidth = Math.min(...linkScores)
    const maxLinkWidth = Math.max(...linkScores)
    const scaleLinkWidth = d3.scaleLinear()
      .domain([minLinkWidth, maxLinkWidth])
      .range([3, 24])

    this.svg = d3.select('.' + styles.facultyGraph)

    let $svg = $('.' + styles.facultyGraph)
    const xCenter = $svg.width() / 2
    const yCenter = $svg.height() / 2
    const linkDist = 60
    const chargeForce = -0.3
    const nodeBuffer = 10
    const lineHeight = 15

    let simulation = d3.forceSimulation()
      .force('link', d3.forceLink().id(d => d.id).distance(() => linkDist))
      .force('charge', d3.forceManyBody().strength(d => chargeForce))
      .force('center', d3.forceCenter(xCenter, yCenter))
      .force('collide', d3.forceCollide(d => scaleRadius(d.score) + nodeBuffer))

    let link = this.svg.append('g')
      .attr('class', styles.links)
      .selectAll('line')
      .data(links)
      .enter()
      .append('line')
        .attr('stroke-width', d => scaleLinkWidth(d.score))

    let node = this.svg.append('g')
      .attr('class', styles.nodes)
      .selectAll(styles.nodes)
      .data(nodes)
      .enter().append('g')
        .attr('r', d => scaleRadius(d.score))

    node.append('circle')
      .attr('name', d => `expand ${d.name}'s faculty info'`)
      .attr('r', d => scaleRadius(d.score))
      .style('fill', d => this.colorHash.hex(d.department))
      .on('click', this.props.onFacultyClick)

    node.append('defs')
      .append('clipPath')
        .attr('id', d => `clipCircle-${d.id}`)
        .append('circle')
          .attr('r', d => scaleRadius(d.score))

    node.append('image')
      .attr('name', d => 'faculty photo')
      .attr('xlink:href', d => d.url)
      .attr('x', d => -scaleRadius(d.score))
      .attr('y', d => -scaleRadius(d.score))
      .attr('width', d => 2 * scaleRadius(d.score))
      .attr('height', d => 2 * scaleRadius(d.score))
      .attr('clip-path', d => `url(#clipCircle-${d.id})`)
      .on('click', this.props.onFacultyClick)
      .on('error', function () {
        $(this).hide()
      })

    node.append('text')
      .text(d => d.name)
      .attr('dy', d => -(scaleRadius(d.score) + 3))

    simulation
      .nodes(nodes)
      .on('tick', ticked)

    simulation
      .force('link')
      .links(links)

    function ticked () {
      link
        .attr('x1', d => d.source.x)
        .attr('y1', d => d.source.y)
        .attr('x2', d => d.target.x)
        .attr('y2', d => d.target.y)

      node
        .attr('transform', d => {
          let r = scaleRadius(d.score)
          d.x = Math.max(r, Math.min(d.x, $svg.width() - r))
          d.y = Math.max(r + lineHeight, Math.min(d.y, $svg.height() - r))

          return `translate(${d.x}, ${d.y})`
        })
    }
  }

  render () {
    return h.div(h.ca(styles.container),
      h.h2(h.ca(styles.graphHeading), 'Faculty Experts'),
      h.svg(h.ca(styles.facultyGraph))
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/FacultyGraph/index.js